import I18n from 'I18n';
import styled from 'styled-components';
import SVGCollapse from 'visitor-ui-component-library-icons/icons/SVGCollapse';
import SVGExpand from 'visitor-ui-component-library-icons/icons/SVGExpand';
import SVGExternalLink from 'visitor-ui-component-library-icons/icons/SVGExternalLink';
import SVGLeft from 'visitor-ui-component-library-icons/icons/SVGLeft';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { hexToRgba } from '../util/color';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KBArticleHeaderWrapper = styled.div.withConfig({
  displayName: "KBArticleHeader__KBArticleHeaderWrapper",
  componentId: "sc-1o46dmk-0"
})(["display:flex;justify-content:space-between;width:100%;"]);
const KBArticleHeaderIcon = styled(VizExIcon).withConfig({
  displayName: "KBArticleHeader__KBArticleHeaderIcon",
  componentId: "sc-1o46dmk-1"
})(["font-size:16px;"]);
const FlexWrapper = styled.div.withConfig({
  displayName: "KBArticleHeader__FlexWrapper",
  componentId: "sc-1o46dmk-2"
})(["display:flex;"]);
const StyledVizExLink = styled(VizExLink).withConfig({
  displayName: "KBArticleHeader__StyledVizExLink",
  componentId: "sc-1o46dmk-3"
})(["display:flex;align-items:center;justify-content:center;width:40px;margin-left:24px;color:", ";&:hover{color:", ";background-color:rgba( ", " );}"], ({
  theme
}) => theme.colors.textOnPrimary, ({
  theme
}) => theme.colors.textOnPrimary, ({
  theme
}) => hexToRgba(theme.colors.textOnPrimary, 0.1));
function KBArticleHeader({
  browserWindowHeight,
  inline,
  kbArticleDeepLink,
  restorePreviousViewFromKBArticle,
  mobile,
  toggleWidgetSizeForKBArticle,
  viewKBArticleExpanded
}) {
  return /*#__PURE__*/_jsxs(KBArticleHeaderWrapper, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(VizExIconButton, {
        onClick: () => restorePreviousViewFromKBArticle(),
        use: "transparent-on-primary",
        "aria-label": I18n.text('conversations-visitor-experience-components.kbArticle.backToChat'),
        children: /*#__PURE__*/_jsx(KBArticleHeaderIcon, {
          icon: /*#__PURE__*/_jsx(SVGLeft, {})
        })
      })
    }), /*#__PURE__*/_jsxs(FlexWrapper, {
      children: [!(mobile || inline) && /*#__PURE__*/_jsx(VizExIconButton, {
        onClick: () => toggleWidgetSizeForKBArticle(browserWindowHeight),
        use: "transparent-on-primary",
        "aria-label": viewKBArticleExpanded ? I18n.text('conversations-visitor-experience-components.kbArticle.collapse') : I18n.text('conversations-visitor-experience-components.kbArticle.expand'),
        children: viewKBArticleExpanded ? /*#__PURE__*/_jsx(KBArticleHeaderIcon, {
          icon: /*#__PURE__*/_jsx(SVGCollapse, {})
        }) : /*#__PURE__*/_jsx(KBArticleHeaderIcon, {
          icon: /*#__PURE__*/_jsx(SVGExpand, {})
        })
      }), /*#__PURE__*/_jsx(StyledVizExLink, {
        href: kbArticleDeepLink,
        "aria-label": I18n.text('conversations-visitor-experience-components.kbArticle.openInNewTab'),
        target: "_blank",
        children: /*#__PURE__*/_jsx(KBArticleHeaderIcon, {
          icon: /*#__PURE__*/_jsx(SVGExternalLink, {})
        })
      })]
    })]
  });
}
KBArticleHeader.displayName = 'KBArticleHeader';
export default KBArticleHeader;